import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersDescriptionEntered
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from, to, amount
 * and description fields set with a value
 */
export default function CaptureTransfersDescriptionEntered(props) {
    // Initalize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // then updating the from, to, amount and description properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .update([ "transfer", "description" ], "Sample")
        .submit();

    // Return the TransfersPage passing the data variable
    return <TransfersPage data={ data } />
}